// extracted by mini-css-extract-plugin
export default {"element":"BackButton_element__+xSzT"};